import React, { useEffect, useState } from "react";
import "./finalclaimreport.css";
import axios from "axios";

import { useParams } from "react-router";
const FinalClaimReport = () => {
  const { claimNumber } = useParams();
  console.log("7", claimNumber);

  const [data, setData] = useState(null);
  const [claimDataS3, setclaimDataS3] = useState(null);
  const [progressData, setProgressData] = useState({});
  const [claimData, setClaimData] = useState(null);
  useEffect(() => {
    const fetchClaimDetails = async () => {
      try {
        const res = await axios.post("/process_data/claim-data", {
          claimNumber,
        });
        console.log("391", res.data);
        setClaimData(res.data);
      } catch (err) {
        console.error("Error fetching claim details:", err);
      }
    };

    if (claimNumber) {
      fetchClaimDetails();
    }
  }, [claimNumber]);
  const formatDateTime = (dateString) => {
    if (!dateString) return "--";

    try {
      const date = new Date(dateString);
      if (isNaN(date)) return "--";

      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");

      return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
    } catch (error) {
      console.error("Error formatting date:", error);
      return "--";
    }
  };
  useEffect(() => {
    const fetchProgress = async () => {
      if (claimNumber) {
        try {
          const res = await axios.post(
            `/process_data/claim_progress/${claimNumber}`,
          );
          setProgressData(res.data);
          console.log("progress-32", res.data);
        } catch (err) {
          console.error("Error fetching claim progress:", err);
        }
      }
    };
    fetchProgress();
  }, [claimNumber]);
  useEffect(() => {
    if (!claimNumber || !progressData) return;

    if (progressData.pre_invoice == "1") {
      console.log("43-pre-invoice-extract");

      axios
        .post(`/server/get-pre-invoice-data/${claimNumber}`)
        .then((response) => {
          console.log("pre-invoice data", response.data);
          setData(response.data);
        })
        .catch((error) => console.error("Axios error:", error));
    } else {
      console.log("54-invoice-extract");

      axios
        .post(`/server/get-invoice-data/${claimNumber}`)
        .then((response) => {
          console.log("invoice data", response.data);
          setData(response.data);
        })
        .catch((error) => console.error("Axios error:", error));
    }
  }, [claimNumber, progressData]);

  useEffect(() => {
    if (claimNumber) {
      axios
        .post(`/server/get-claim-data/${claimNumber}`)
        .then((response) => {
          console.log("claimDataS3", response.data);

          setclaimDataS3(response.data);
        })
        .catch((error) => console.error("Axios error:", error));
    }
  }, [claimNumber]);
  const parseAmount = (value) => {
    if (value === null || value === undefined) return NaN;
    if (typeof value === "string") {
      const cleaned = value.replace(/,/g, "").trim();
      return Number(cleaned);
    }
    return Number(value);
  };

  const formatAmount = (value) => {
    const num = parseAmount(value);
    return isNaN(num) ? "--" : `₹${num.toFixed(2)}`;
  };

  const formatNumber = (value) => {
    const num = parseAmount(value);
    return isNaN(num) ? 0 : num;
  };

  const rawData = data?.data || data || {};
  const combinedData = {
    ...(claimDataS3 || {}),
    ...rawData,
    parts_details: rawData.parts_details || rawData.parts || [],
    labour_details: rawData.labour_details || rawData.labourDetails || [],
  };
  console.log("combinedData", combinedData);
  if (!data || !claimDataS3) return <div>Loading...</div>;
  return (
    <div className="report-containerrr">
      <div className="report-header">
        <img
          src="/custom-icons/surveyorIcon.png"
          alt="Surveyor AI Logo"
          className="logo"
        />
        <div className="report-title">
          <h2>Final Assessment Report</h2>
        </div>
        <p className="printed-date">
          Printed:{" "}
          {new Date().toLocaleDateString("en-IN", {
            day: "numeric",
            month: "short",
            year: "numeric",
          })}
        </p>
      </div>

      <div className="inline-box-row">
        <div className="inline-box label">Policy Number</div>
        <div className="inline-box value">
          {combinedData.policyNumber || "--"}
        </div>
        <div className="inline-box label">Claim Number</div>
        <div className="inline-box value">
          {combinedData.claimNumber || "--"}
        </div>
        <div className="inline-box label">Ticket Number</div>
        <div className="inline-box value">
          {combinedData?.workshop_details?.ticket_number || "--"}
        </div>
      </div>
      {/* 
      <div className='inline-box-row info-box'>
        <div className='info-full-row'>
          <div className='inline-box label'>Date:</div>
          <div className='inline-box value'>
            {new Date().toLocaleString('en-IN', {
              day: 'numeric',
              month: 'short',
              year: 'numeric',
              hour: 'numeric',
              minute: 'numeric',
              hour12: true
            })}
          </div>
        </div>

        <div className='info-row'>
          <div className='inline-box label'>Name of Owner:</div>
          <div className='inline-box value'>{combinedData.insured || '--'}</div>
          <div className='inline-box label'>Engine No.:</div>
          <div className='inline-box value'>
            {combinedData.EngineNumber || '--'}
          </div>
          <div className='inline-box label'>Workshop Name:</div>
          <div className='inline-box value'>
            {combinedData?.workshop_details?.workshop_name || '--'}
          </div>
        </div>

        <div className='info-row'>
          <div className='inline-box label'>Registration No.:</div>
          <div className='inline-box value'>
            {combinedData.VehicleRegistrationNumber || '--'}
          </div>
          <div className='inline-box label'>Surveyor Name:</div>
          <div className='inline-box value'>Not Mentioned</div>
          <div className='inline-box label'>Workshop GST Number:</div>
          <div className='inline-box value'>
            {combinedData?.workshop_details?.workshop_gst_number || '--'}
          </div>
        </div>

        <div className='info-row'>
          <div className='inline-box label'>Date of Reg.:</div>
          <div className='inline-box value'>
            {combinedData.DateofRegistration || '--'}
          </div>
          <div className='inline-box label'>Claim Coordinator:</div>
          <div className='inline-box value'>--</div>
          <div className='inline-box label'>Date of Accident:</div>
          <div className='inline-box value'>
            {combinedData.dateOfAccident || '--'}
          </div>
        </div>

        <div className='info-row'>
          <div className='inline-box label'>Make & Model:</div>
          <div className='inline-box value'>
            {combinedData.Make || '--'} {combinedData.Variant || ''}
          </div>
          <div className='inline-box label'>Chassis No.:</div>
          <div className='inline-box value'>
            {combinedData.ChassisNumber || '--'}
          </div>
          <div className='inline-box label'>Vehicle Age (Years):</div>
          <div className='inline-box value'>
            {combinedData?.workshop_details?.vehicle_age || '--'}
          </div>
        </div>

        <div className='info-row'>
          <div className='inline-box label'>Payment to:</div>
          <div className='inline-box value'>
            {combinedData?.workshop_details?.payment_to || '--'}
          </div>
        </div>
      </div>  */}
      <div className="inline-box-row info-box">
        <div className="info-full-row">
          <div className="inline-box label">
            Date:{formatDateTime(new Date())}
          </div>
          <div className="inline-box value">{claimData?.date || "--"}</div>
        </div>

        <div className="info-row">
          <div className="inline-box label">Name of Owner:</div>
          <div className="inline-box value">
            {combinedData?.insured || claimData?.customer_name || "--"}
          </div>

          <div className="inline-box label">Engine No.:</div>
          <div className="inline-box value">
            {combinedData?.EngineNumber || claimData?.engine_number || "--"}
          </div>

          <div className="inline-box label">Workshop Name:</div>
          <div className="inline-box value">
            {claimData?.workshop_name || "--"}
          </div>
        </div>

        <div className="info-row">
          <div className="inline-box label">Registration No.:</div>
          <div className="inline-box value">
            {claimData?.vehicle_number || "--"}
          </div>

          <div className="inline-box label">Surveyor Name:</div>
          <div className="inline-box value">Surveyor's Ai</div>

          <div className="inline-box label">Workshop GST Number:</div>
          <div className="inline-box value">
            {claimData?.workshop_gst || "--"}
          </div>
        </div>

        <div className="info-row">
          <div className="inline-box label">Date of Reg.:</div>
          <div className="inline-box value">
            {formatDateTime(combinedData?.DateofRegistration)}
          </div>

          <div className="inline-box label">Claim Coordinator:</div>
          <div className="inline-box value">
            {claimData?.claimCoordinator || "--"}
          </div>

          <div className="inline-box label">Date of Accident:</div>
          <div className="inline-box value">
            {formatDateTime(claimData?.accident_datetime)}
          </div>
        </div>

        <div className="info-row">
          <div className="inline-box label">Make & Model:</div>
          <div className="inline-box value">
            {claimData?.make || ""} {claimData?.model || "--"}{" "}
            {claimData?.variant || "--"}
          </div>

          <div className="inline-box label">Chassis No.:</div>
          <div className="inline-box value">
            {combinedData?.ChassisNumber || claimData?.chassis_number || "--"}
          </div>

          <div className="inline-box label">Vehicle Age (Years):</div>
          <div className="inline-box value">
            {(() => {
              const regDateRaw = combinedData?.DateofRegistration;
              const accidentRaw = claimData?.accident_datetime;

              if (regDateRaw && accidentRaw) {
                const regDate = new Date(regDateRaw);
                const accidentDate = new Date(accidentRaw);

                if (!isNaN(regDate) && !isNaN(accidentDate)) {
                  let years =
                    accidentDate.getFullYear() - regDate.getFullYear();
                  let months = accidentDate.getMonth() - regDate.getMonth();
                  let days = accidentDate.getDate() - regDate.getDate();

                  if (days < 0) {
                    months -= 1;
                    days += new Date(
                      accidentDate.getFullYear(),
                      accidentDate.getMonth(),
                      0,
                    ).getDate();
                  }

                  if (months < 0) {
                    years -= 1;
                    months += 12;
                  }

                  years = Math.max(years, 1);

                  return `${years} Years ${months} Months`;
                }
              }

              return "--";
            })()}
          </div>
        </div>

        <div className="info-row">
          <div className="inline-box label">Payment to:</div>
          <div className="inline-box value">Workshop</div>
        </div>
      </div>
      <div className="note-section">
        <p>
          "Please find the below tentative estimation for the subject vehicle as
          per the visible damages..."
        </p>
        <p>
          <strong>Important Notes:</strong>
        </p>
        <ul>
          <li>
            After completion of repair, you shall submit the vehicle for
            reinspection...
          </li>
          <li>
            Final tax invoice raised in favor of Surveyor Insurance Limited...
          </li>
        </ul>
        {/* <p className='help-note'>
          For any further clarifications regarding your claim: Contact TPA at
          support@insurancecompany.com or +91 9810498126
        </p> */}
        <p className="help-note">
          For any further clarifications regarding your claim: Contact TPA
          at&nbsp;
          {/* {formData.email_id || ' support@tpa.com'} or{' '}
          {formData.phone_number || ' +91-XXXXX-XXXXX'} */}
          {"surveyor@surveyor.com"} or {" +91-9876543210"}
        </p>
      </div>

      <h4 className="section-heading">PARTS</h4>
      <table className="parts-table">
        <thead>
          <tr>
            <th>SN</th>
            <th>JOB</th>
            <th>MATERIAL</th>
            <th>DESCRIPTION</th>
            <th>HSN</th>
            <th>QTY</th>
            <th>PART RATE</th>
            <th>TAXABLE AMOUNT</th>
            <th>TAX (%)</th>
            <th>TAX AMOUNT</th>
            <th>TOTAL AMOUNT</th>
            <th>DEP (%)</th>
            <th>DEP AMOUNT</th>
            <th>R&R CHARGES</th>
            <th>REPAIR CHARGES</th>
            <th>PAINTING CHARGES</th>
          </tr>
        </thead>
        {/* <tbody>
          {combinedData?.parts?.map((part, i) => {
            const qty = Number(part.qty || 0)
            const rate = Number(part.rate || 0)
            const taxPercent = Number(part.taxPercent || 0)
            const depPercent = Number(part.depPercent || 0)
            const taxableAmount = qty * rate
            const taxAmount = (taxableAmount * taxPercent) / 100
            const totalAmount = taxableAmount + taxAmount
            const depAmount = (taxableAmount * depPercent) / 100

            return (
              <tr key={i}>
                <td>{i + 1}</td>
                <td>{part.job}</td>
                <td>{part.material}</td>
                <td>{part.description}</td>
                <td>{part.hsn}</td>
                <td>{part.qty}</td>
                <td>{part.rate}</td>
                <td>₹{taxableAmount.toFixed(2)}</td>
                <td>{part.taxPercent}</td>
                <td>₹{taxAmount.toFixed(2)}</td>
                <td>₹{totalAmount.toFixed(2)}</td>
                <td>{part.depPercent}</td>
                <td>₹{depAmount.toFixed(2)}</td>
                <td>₹{part.rrCharges}</td>
                <td>₹{part.repairCharges}</td>
                <td>₹{part.paintingCharges}</td>
              </tr>
            )
          })}
          {combinedData?.parts && (
            <tr className='subtotal-row'>
              <td colSpan='7'>
                <strong>Subtotal</strong>
              </td>
              <td>
                ₹
                {combinedData.parts
                  .reduce((sum, p) => sum + Number(p.qty) * Number(p.rate), 0)
                  .toFixed(2)}
              </td>
              <td></td>
              <td>
                ₹
                {combinedData.parts
                  .reduce((sum, p) => {
                    const taxBase = Number(p.qty) * Number(p.rate)
                    return sum + (taxBase * Number(p.taxPercent)) / 100
                  }, 0)
                  .toFixed(2)}
              </td>
              <td>
                ₹
                {combinedData.parts
                  .reduce((sum, p) => {
                    const taxBase = Number(p.qty) * Number(p.rate)
                    const taxAmount = (taxBase * Number(p.taxPercent)) / 100
                    return sum + taxBase + taxAmount
                  }, 0)
                  .toFixed(2)}
              </td>
              <td></td>
              <td>
                ₹
                {combinedData.parts
                  .reduce((sum, p) => {
                    const taxBase = Number(p.qty) * Number(p.rate)
                    return sum + (taxBase * Number(p.depPercent)) / 100
                  }, 0)
                  .toFixed(2)}
              </td>
              <td colSpan='5'></td>
            </tr>
          )}
        </tbody> */}
        <tbody>
          {combinedData?.parts_details?.length > 0 ? (
            combinedData.parts_details.map((part, i) => {
              const qty = formatNumber(part.qty);
              const rate = formatNumber(part.rate);
              const taxableAmount = formatNumber(part.taxable_amount);
              const taxPercent =
                part.tax_percentage !== "" && part.tax_percentage != null
                  ? formatNumber(part.tax_percentage)
                  : 18;
              const taxAmount = !Number.isNaN(parseAmount(part.tax_amount))
                ? parseAmount(part.tax_amount)
                : (taxableAmount * taxPercent) / 100;
              const totalAmount = !Number.isNaN(parseAmount(part.total_amount))
                ? parseAmount(part.total_amount)
                : taxableAmount + taxAmount;
              const depPercent =
                part.dep_percentage !== "" && part.dep_percentage != null
                  ? formatNumber(part.dep_percentage)
                  : 0;
              const depAmount = !Number.isNaN(parseAmount(part.dep_amount))
                ? parseAmount(part.dep_amount)
                : (taxableAmount * depPercent) / 100;
              return (
                <tr key={i}>
                  <td>{i + 1}</td>
                  <td>{part.job || part.decision || ""}</td>
                  <td>{part.material || ""}</td>
                  <td>{part.description || ""}</td>
                  <td>{part.hsn || ""}</td>
                  <td>{qty}</td>
                  <td>{rate}</td>
                  <td>{formatAmount(taxableAmount)}</td>
                  <td>{taxPercent}</td>
                  <td>{formatAmount(taxAmount)}</td>
                  <td>{formatAmount(totalAmount)}</td>
                  <td>{depPercent}</td>
                  <td>{formatAmount(depAmount)}</td>
                  <td>{formatAmount(part.r_and_r_charges ?? 0)}</td>
                  <td>{formatAmount(part.repair_charges ?? 0)}</td>
                  <td>{formatAmount(part.painting_charges ?? 0)}</td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan="16">No parts details available</td>
            </tr>
          )}

          {/* Subtotal Row */}
          {combinedData?.parts_details?.length > 0 && (
            <tr className="subtotal-row">
              <td colSpan="7">
                <strong>Subtotal</strong>
              </td>
              <td>
                {formatAmount(
                  combinedData.parts_details.reduce((sum, p) => {
                    const qty = formatNumber(p.qty);
                    const rate = formatNumber(p.rate);
                    return sum + qty * rate;
                  }, 0),
                )}
              </td>
              <td></td>
              <td>
                {formatAmount(
                  combinedData.parts_details.reduce((sum, p) => {
                    const qty = formatNumber(p.qty);
                    const rate = formatNumber(p.rate);
                    const percent = formatNumber(p.tax_percentage);
                    return sum + (qty * rate * percent) / 100;
                  }, 0),
                )}
              </td>
              <td>
                {formatAmount(
                  combinedData.parts_details.reduce((sum, p) => {
                    const taxable = formatNumber(p.taxable_amount);
                    const taxAmount = formatNumber(p.tax_amount);
                    return sum + taxable + taxAmount;
                  }, 0),
                )}
              </td>
              <td></td>
              <td>
                {formatAmount(
                  combinedData.parts_details.reduce((sum, p) => {
                    const taxable = formatNumber(p.taxable_amount);
                    const depPercent = formatNumber(p.dep_percentage);
                    return sum + (taxable * depPercent) / 100;
                  }, 0),
                )}
              </td>
              <td colSpan="5"></td>
            </tr>
          )}
        </tbody>
      </table>

      <h4 className="section-heading">LABOUR</h4>
      <table className="labor-table">
        <thead>
          <tr>
            <th>LABOUR TYPE</th>
            <th>TAXABLE AMOUNT</th>
            <th>TAX AMOUNT</th>
            <th>TOTAL AMOUNT</th>
            <th>DEP AMOUNT</th>
          </tr>
        </thead>
        <tbody>
          {combinedData?.labour_details?.length > 0 ? (
            combinedData.labour_details.map((labour, index) => {
              return (
                <tr key={index}>
                  <td>
                    {labour.labour_type === "Not Found"
                      ? "--"
                      : labour.labour_type || "--"}
                  </td>
                  <td>{formatAmount(labour.taxable_amount)}</td>
                  <td>{formatAmount(labour.tax_amount)}</td>
                  <td>{formatAmount(labour.total_amount)}</td>
                  <td>{formatAmount(labour.dep_amount)}</td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan="5">No labour details available</td>
            </tr>
          )}
        </tbody>
      </table>

      <h4 className="section-heading">FINAL CALCULATION</h4>
      {(() => {
        const parts = combinedData?.parts_details || [];
        const labour = combinedData?.labour_details || [];

        const partsTotalAmount = parts.reduce((sum, p) => {
          const taxable = formatNumber(p.taxable_amount);
          const taxAmount = formatNumber(p.tax_amount);
          return sum + taxable + taxAmount;
        }, 0);

        const labourTotalAmount = labour.reduce((sum, l) => {
          const amount = parseAmount(l.total_amount);
          return sum + (isNaN(amount) ? 0 : amount);
        }, 0);

        const totalLiability = parseFloat(
          (partsTotalAmount + labourTotalAmount).toFixed(2),
        );
        const compulsoryDeductible =
          parseAmount(combinedData?.final_calculation?.compulsory_deductable) ||
          1000;
        const insurerLiability = parseFloat(
          (totalLiability - compulsoryDeductible).toFixed(2),
        );

        return (
          <table className="final-table">
            <thead>
              <tr>
                <th>FINAL CALCULATION</th>
                <th>AMOUNT</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Total Liability</td>
                <td>{formatAmount(totalLiability)}</td>
              </tr>
              <tr>
                <td>Compulsory Deductible</td>
                <td>{formatAmount(compulsoryDeductible)}</td>
              </tr>
              <tr>
                <td>Voluntary Deductible</td>
                <td>
                  {formatAmount(
                    combinedData?.final_calculation?.voluntary_deductible,
                  )}
                </td>
              </tr>
              <tr>
                <td>Salvage Deductions</td>
                <td>
                  {formatAmount(
                    combinedData?.final_calculation?.salvage_deductions,
                  )}
                </td>
              </tr>
              <tr>
                <td>Non-Standard Amount</td>
                <td>
                  {formatAmount(
                    combinedData?.final_calculation?.non_standard_amount,
                  )}
                </td>
              </tr>
              <tr>
                <td>Towing Amount</td>
                <td>
                  {formatAmount(combinedData?.final_calculation?.towing_amount)}
                </td>
              </tr>
              <tr className="total-row">
                <td>Insurer Liability</td>
                <td>{formatAmount(insurerLiability)}</td>
              </tr>
            </tbody>
          </table>
        );
      })()}

      <div className="note-section">
        <div className="section-heading">ASSESSMENT NOTES</div>
        <ul className="assessment-notes">
          <li>
            Any additional amount over and above the approved assessment shall
            be borne by the Insured.
          </li>
          <li>
            The final liability has been arrived at as full and final settlement
            after consent from the Insured...
          </li>
        </ul>
      </div>

      {/* <div className='button-group'>
        <button className='approve-btn' onClick={handleApproveClick}>
          Approve
        </button>
        <button className='manual-btn' onClick={handleManualqcClick}>
          Manual QC
        </button>
      </div> */}
    </div>
  );
};

export default FinalClaimReport;
